import { TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import LearnerDashboardBookmarks from '@/client/components/learners/dashboard/pages/LearnerDashboardBookmarks';
import LearnerDashboardCustomTab from '@/client/components/learners/dashboard/components/tabs/LearnerDashboardCustomTab';
import LearnerDashboardRecentlyViewed from '@/client/components/learners/dashboard/pages/LearnerDashboardRecentlyViewed';
import LearnerDashboardRecommendations from '@/client/components/learners/dashboard/pages/LearnerDashboardRecommendations';
import { useAccessHelper } from '@/client/services/hooks/auth/useAccessHelper';
import { useLearnerDashboardStore } from '../../learnerDashboardStore';
import { useTranslation } from 'react-i18next';

export default function LearnerDashboardOverviewBrowseTabs() {
  const { t } = useTranslation();
  const { setSelectedOverviewTabId } = useLearnerDashboardStore();
  const { allowance } = useAccessHelper();
  const { recommendations } = allowance;

  return (
    <Tabs>
      <TabList position="sticky" top={0} backgroundColor="white" zIndex={1} paddingBottom={2}>
        <LearnerDashboardCustomTab onClick={() => setSelectedOverviewTabId('bookmarks')}>
          {t('learners.dashboard.bookmarks')}
        </LearnerDashboardCustomTab>

        <LearnerDashboardCustomTab onClick={() => setSelectedOverviewTabId('recently-viewed')}>
          {t('learners.dashboard.recentlyViewed')}
        </LearnerDashboardCustomTab>

        {recommendations && (
          <LearnerDashboardCustomTab onClick={() => setSelectedOverviewTabId('for-you')}>
            {t('learners.dashboard.forYou')}
          </LearnerDashboardCustomTab>
        )}
      </TabList>

      <TabPanels marginTop={6}>
        <TabPanel padding={0}>
          <LearnerDashboardBookmarks />
        </TabPanel>

        <TabPanel padding={0}>
          <LearnerDashboardRecentlyViewed />
        </TabPanel>

        {recommendations && (
          <TabPanel padding={0}>
            <LearnerDashboardRecommendations />
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
}
